<template>
  <div>
    <span class="font-bold text-slate-800">Photo</span>
    <span class="text-slate-500">Diagram</span>
  </div>
</template>